import { render, staticRenderFns } from "./SchemeSearchAndDocuments.vue?vue&type=template&id=660495f6&scoped=true&"
import script from "./SchemeSearchAndDocuments.vue?vue&type=script&lang=ts&"
export * from "./SchemeSearchAndDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SchemeSearchAndDocuments.vue?vue&type=style&index=0&id=660495f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660495f6",
  null
  
)

export default component.exports